/**
 * Function to enable the active links for links/navs and match the current location with the specific nav
 * @param {string} location - The current page/window location, based on the window object and
 * @param {string} path - The path to compare the current page/window location
 * @returns {boolean} True/false if the path matches the current location
 */
export default function (location, path) {
    // If location or path is empty returns false
    if (!location) return false;
    // Checks if location is same as path
    if (location === path) return true;
    // Checks if location has a pathname key and is same as path
    else if (location.pathname && location.pathname === path) return true;
    // If the location doesn't match
    return false;
}
